$(() => {
    const calcNums = (rowTotals = []) => (i, elem) => {
        const $nums = $(elem).find('.b-complete-numbers__num');
        let result = 0;
        $nums.each((i, elem) => result += $(elem).data('value') || 0)
        rowTotals.push(result);
        
        $nums.each((i, elem) => {
            const $elem = $(elem);
            const value = $elem.data('value');
            const percent = value / result * 100;
            $elem.css('flex-basis', `${percent}%`)
        });
    }

    const initNumbers = () => {
        $('.b-complete-numbers').each((i, elem) => {
            const $block = $(elem);
            const $rows = $block.find('.b-complete-numbers__row:not(.is-total)');
            const $totalRows = $block.find('.b-complete-numbers__row.is-total');
            const rowTotals = [];
            
            const decreaseFactor = $totalRows.length > 0 ? 0.8 : 1;

            $rows.each(calcNums(rowTotals));

            const rowMax = rowTotals.reduce((res, curr) => Math.max(res, curr), 0);

            $rows.each((i, elem) => {
                const percent = rowTotals[i] / rowMax * decreaseFactor * 100;
                $(elem).find('.b-complete-numbers__numbers').css('width', `${percent}%`);
            })

            $totalRows.each(calcNums());
        })
    };

    $(initNumbers);
});